import request from "@src/utils/request";
import { PaginatedResponse } from "@src/types/notification";
import { PaginationValues } from "@src/types/pagination";
import { FavoriteProduct } from "@src/types/favoriteProduct";
import type { Response } from "superagent";

export async function getFavoriteProductIds(): Promise<
  Response & { body: { ids: string[] } }
> {
  return request()
    .get("/api/v1/favorite-products/ids/")
    .send() as Promise<Response & { body: { ids: string[] } }>;
}

export async function getFavoriteProducts(paginationFilters?: PaginationValues) {
  return request()
    .query({
      page: paginationFilters?.page,
      pageSize: paginationFilters?.pageSize,
    })
    .get("/api/v1/favorite-products/")
    .send() as Promise<Response & { body: PaginatedResponse<FavoriteProduct> }>;
}

export function favoriteProduct(productId: string) {
  return request().post(`/api/v1/products/${productId}/favorite/`).send();
}

export function unfavoriteProduct(productId: string) {
  return request().delete(`/api/v1/products/${productId}/unfavorite/`).send();
}
